export enum TokenStatus {
  READY_FOR_USE = 'READY_FOR_USE',
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED'
}
